import React, { useState, useEffect } from 'react'
import { getCurrentDate } from '../../Utils/Dateutils';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox
} from '@mui/material';
import TitleBar from '../TitleBar';
import { ReceiptMenu, ReportMenu } from '../TitleList';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Dropdown from '../FieldsComponents/Dropdown';
import RadioComponent from '../FieldsComponents/RadioComponent';
import TextareaComponent from '../FieldsComponents/TextareaComponent';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm } from '../Selectors/Master/ItemSelectors';

const SalesLedgerStatement = () => {

    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        partyType: '',
        partyNm: '',
        fromDt: '',
        toDt: '',
        cat: '',
        userId: userdata?.ID
    });

    const dispatch = useDispatch();
    const firmList = useSelector(selectFirm);

    useEffect(() => {
        dispatch(fetchCompanyData());
    }, [dispatch]);


    const isDesktop = useMediaQuery('(min-width:768px)');
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            toDt: e.target.value,fromDt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const dropdownlistfirst = [
        {
            label: 'Firm Name',
            id: 'firmId',
            options: firmList?.data || [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Party Type',
            id: 'partyType',
            options: [],
            value: formData.partyType,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'partyType', value: newValue ? newValue.ID : '' } }, 'partyType'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Party Name',
            id: 'partyNm',
            options: [],
            value: formData.partyNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'partyNm', value: newValue ? newValue.ID : '' } }, 'partyNm'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
        label: 'Category',
        id: 'cat',
        options: [],
        value: formData.cat,
        onChange: (newValue) => handleDropdownChange({ target: { name: 'cat', value: newValue ? newValue.ID : '' } }, 'cat'),
        getOptionLabel: (option) => option.partyNm || '',
        isOptionEqualToValue: (option, value) => option.ID === value.ID,
        valueFinder: (options, value) => {
            if (Array.isArray(options)) {
                return options.find(item => item.ID === value) || null;
            }
            return null;
        },
    }

    ];

    const dateFields = [
        { label: 'From Date', name: 'fromDt', type: 'date' },
        { label: 'To Date', name: 'toDt', type: 'date' }

    ];

    const handleDropdownChange = async (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };



 
    return (
        <>
            <TitleBar data={ReportMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Sales Ledger Statement</h2>


                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {dateFields.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                            </Grid>

                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    )
}

export default SalesLedgerStatement;
